<div class="container" #contentDiv>
  <div class="content-div">
    <p class="heading">Let’s get you connected!</p>
    <p class="description">
      It looks like the email you provided isn’t linked to Futurenav™ Compass. Try signing in with your school email.
    </p>
    <p class="sub-description">
      Want to learn more or request access? Contact
      <a href="mailto:CompassSupport@ets.org">
        CompassSupport&#64;ets.org
      </a>
    </p>

    <div class="actions">
      <button class="btn" (click)="navigateToSignIn()">
        Back to Sign In
      </button>
    </div>
  </div>
</div>
